import React from "react";
import { Helmet } from "react-helmet";

import Nav from "./Nav";
import Footer from "./Footer";
import HomepageRedesign from "./homepage/HomepageRedesign";
import { SEO_SHARE_IMAGES } from "../lib/seoImages";

function MainPage() {
  const shareImage = SEO_SHARE_IMAGES.homepage;

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Speak Your Menu",
    url: "https://speakyourmenu.com/",
    logo: "https://speakyourmenu.com/SpeakYourMenu_Logo.png",
    email: "support@speakyourmenu.com",
    sameAs: [
      "https://www.instagram.com/speakyourmenu",
      "https://www.facebook.com/speakyourmenu",
      "https://www.linkedin.com/company/speakyourmenu"
    ]
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Restaurant Training App | Menu Training for Front of House Staff</title>
        <meta name="description" content="Speak Your Menu is the leading restaurant training app for menu education, front of house staff, servers, restaurant owners, and managers. Mobile menu training for restaurants." />
        {/* Open Graph */}
        <meta property="og:title" content="Restaurant Training App | Menu Training for Front of House Staff" />
        <meta property="og:description" content="Speak Your Menu is the leading restaurant training app for menu education, front of house staff, servers, restaurant owners, and managers. Mobile menu training for restaurants." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://speakyourmenu.com/" />
          <meta property="og:image" content={shareImage} />
        <meta property="og:site_name" content="Speak Your Menu" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Restaurant Training App | Menu Training for Front of House Staff" />
        <meta name="twitter:description" content="Speak Your Menu is the leading restaurant training app for menu education, front of house staff, servers, restaurant owners, and managers. Mobile menu training for restaurants." />
          <meta name="twitter:image" content={shareImage} />
        <meta name="twitter:site" content="@speakyourmenu" />
        {/* Canonical URL */}
        <link rel="canonical" href="https://speakyourmenu.com/" />
        {/* BreadcrumbList JSON-LD */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {"@type": "ListItem", "position": 1, "name": "Home", "item": "https://speakyourmenu.com/"}
          ]
        })}</script>
        {/* Organization JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
        {/* WebSite JSON-LD */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Speak Your Menu",
          "url": "https://speakyourmenu.com/",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://speakyourmenu.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })}</script>
        {/* To update keywords or URLs, edit above meta tags and JSON-LD. */}
      </Helmet>
      <Nav />
      <main id="main-content" tabIndex="-1">
        <HomepageRedesign />
      </main>
      <Footer />
    </>
  );
}

export default MainPage;
